<template>
  <div class="position-relative">
    <b-container>
      <b-row class="stepperdiv">
        <b-col lg="6" md="6" sm="6" cols="2">
          <BackToMasters :goback="$router.back"></BackToMasters>
          <Headerlayout
            :headertext="$t('ItemCategory.RateContract.Master')"
            :contenttext="$t('ItemCategory.RateContract.content')"
          />
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="2">
          <Footer @click="IsSubmit" />
        </b-col>
      </b-row>
      <b-form class="row form-white-bg">
        <b-row>
          <b-col lg="12">
            <SupplierComponent
              v-model="SupformData"
              @item-update="handleItemUpdate"
              :disabled="SupplierDropDownDisable"
              @update:modelValue="SupplierValue"
              :commonItemProps="commonItemProps"
              :cardshow="false"
            />
          </b-col>
        </b-row>

        <b-row class="pb-0">
          <b-col lg="3" md="4" sm="6">
            <div class="field">
              <!-- <ItemView
                @additemclick="AddItems"
                v-model:data-items="dataItems"
                :show-fields="showFields"
                v-model:addItemData="items"
                :commonItemProps="commonItemProps"
                @calculation="TotalGrossCalc"
                :isFilterData="itemDatas"
              /> -->
              <label
                >{{ $t("5003.itemname") }}<span class="red"> *</span></label
              >
              <AutoCompleteCustom
                v-model="ItemData.Itemname1"
                :items="LoadItemName.ITEMoption"
                @keydown="LoadItem"
                class="autoItem"
                @item-select="ItemOnChange"
                name="ItemName"
                id="ItemName"
                :optionAttrs="(item) => ({ extraValue: item.ItemQuantity })"
                :disabled="disabledval"
                :required-icon="true"
              />
              <!-- :rules="{ required: true }" -->
            </div>
          </b-col>
          <b-col lg="3" md="4" sm="6">
            <div class="field">
              <Datepickers
                :label="$t('ItemCategory.RateContract.fromdate')"
                v-model="ItemData.FromDate"
                name="FromDate"
                id="FromDate"
                :disabled="chkDisabled.datepicker"
                :required-icon="showFields.FromDate?.require"
                :maxDate="TodayDate"
              />
              <!-- :rules="{ required: showFields.FromDate?.require }" -->
            </div>
          </b-col>
          <b-col lg="3" md="4" sm="6">
            <div class="field">
              <Datepickers
                :label="$t('ItemCategory.RateContract.todate')"
                v-model="ItemData.ToDate"
                name="ToDate"
                id="ToDate"
                :disabled="chkDisabled.datepicker == true"
                :required-icon="showFields.ToDate?.require"
                :maxDate="TodayDate"
                :minDate="
                  ItemData.FromDate ? new Date(ItemData.FromDate) : undefined
                "
              />
              <!-- :rules="{ required: showFields.ToDate?.require }" -->
            </div>
          </b-col>
          <b-col lg="3" md="4" sm="6">
            <div class="field mt-5">
              <div class="d-flex align-items-center">
                <Checkbox
                  inputId="alwaysvalid"
                  name="alwaysvalid"
                  :value="1"
                  v-model="ItemData.IsValid"
                  :binary="true"
                  @change="AlwaysValidChng"
                />
                <label for="alwaysvalid" class="ms-2 mb-0">
                  {{ $t("ItemCategory.RateContract.alwaysvalid") }}
                </label>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex flex-row-reverse">
            <div class="btn-class-name">
              <AddButton
                :btnname="AddBtnName"
                type="submit"
                @click="IsAddItem"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <Tableview
              :value="items"
              class="p-datatable-gridlines mt-5"
              :rowHover="true"
              filterDisplay="menu"
              responsiveLayout="scroll"
              :columns="columns"
            >
              <template v-slot:Add>
                <span>
                  <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                </span>
              </template>

              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsItemEdit(data)" />
                  <DeleteIcon @click="IsItemDelete(data)" />
                </span>
              </template>
            </Tableview>
            <!-- <Tableview :columns="columns" :data="List">
              <template v-slot:Add>
                <span>
                  <AddButton :btnname=" $t('btn.plusaddnew')"></AddButton>
                </span>
              </template>
              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsItemEdit(data)" />
                  <DeleteIcon @click="IsItemDelete(data)" />
                </span>
              </template>
            </Tableview> -->

            <!-- <EditTable :data="List" :columns="columns">
              <template v-slot:FromDate="{ data }">
                hhs
              </template>
            </EditTable> -->
          </b-col>
        </b-row>
      </b-form>
    </b-container>
    <div class="center" v-if="loading">
      <Loader :loading="loading" />
    </div>
  </div>
  <createdsuccessfully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, watch } from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import SupplierComponent from "../../../../../modules/Inventory/components/Transaction/SupplierComponent.vue";
import ItemView from "../../../../../modules/Inventory/components/Transaction/Item.vue";
import Tableview from "../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import RateContractService from "../../../../../modules/Inventory/Service/RateContractService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import createdsuccessfully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import Datepickers from "../../../../../components/FormComponents/DatePicker.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { parse } from "path";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import AutoCompleteCustom from "../../../../../components/FormComponents/AutoComplete.vue";
import Itemservice from "../../../Service/ItemMasService";
import AddButton from "../../../../../components/GeneralButtons/AddButton.vue";
import DataView from "primevue/dataview";
import { useToast } from "primevue/usetoast";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
  components: {
    createdsuccessfully,
    UpdatedSuccessfully,
    Datepickers,
    BackToMasters,
    Headerlayout,
    SupplierComponent,
    ItemView,
    Tableview,
    Footer,
    Loader,

    AutoCompleteCustom,
    AddButton,
  },

  setup(props) {
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const { t } = useI18n();
    let loading1 = ref(false);
    let loading = ref(false);
    const itemDatas = ref([]);
    const commonItemProps = ref({
      storeId: 0,
      type: 0,
      supplierId: 0,
      itemType: 2,
      IsFilter: 0,
    });

    const router = useRoute();
    const routers = useRouter();
    const toast = useToast();
    const TodayDate = new Date();
    const EditID = router.query.Id;
    let AddBtnName = ref("Add");
    const visible = ref(false);
    const updatepop = ref(false);

    let StoreId = router.query.StoreId;
    //  let OperationId = Number(router.query.OperationId) ?? 0;
    // let Entitydata = ref();
    // Entitydata.value = JSON.parse(localStorage.getItem("EntityData") as string);
    // Entitydata.value = Entitydata.value.EntityId;

    commonItemProps.value.storeId = Number(StoreId);
    let loginStoreId;
    let items: any = ref([]);

    let disabledval = ref(false);
    const dataItems = ref({});
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      TableEdit(dataItems.value);
      AlwaysValidChng();
    }

    let rccreate = ref({
      CreatedAt: "2023-04-03T09:20:16.187Z",
      ModifiedAt: "2023-04-03T09:20:16.187Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "string",
      Id: 0,
      StoreId: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      IsValid: 0,
    });

    let ItemData = ref({
      Itemname1: "",
      ItemId: 0,
      ItemCode: "",
      HSNCode: "",
      FromDate: "",
      ToDate: "",
      IsValid: 0,
    });

    function SupplierValue(data) {
      debugger;
      commonItemProps.value.supplierId = data.SupplierId;
    }

    const LoadItemName = ref({
      ITEMid: null,
      ITEMoption: [],
    });

    async function LoadItem() {
      debugger;
      try {
        let FromStoreId: any = router.query.StoreId;
        let ToStoreId = 0;
        let Type = 0;
        if (FromStoreId != 0 && FromStoreId != "") {
          const dataresponse = await Itemservice.GetItemByStoresId(
            FromStoreId,
            ToStoreId,
            ItemData.value.Itemname1,
            commonItemProps.value.itemType,
            commonItemProps.value.supplierId,
            router.query.StoreBrMapId,
            0,
            HospitalId
          );
          LoadItemName.value.ITEMoption = dataresponse["result"].map(
            (item: any) => {
              item.label = item.Name;
              item.value = item.Id;
              return item;
            }
          );
        }
      } catch (error) {}
    }

    const ItemOnChange = (ItemId) => {
      debugger;
      ItemData.value.ItemId = ItemId.value.Id;
      ItemData.value.Itemname1 = ItemId.value.label;
      ItemData.value.ItemCode = ItemId.value.Code;
    };

    function IsAddItem() {
      debugger;

      if (
        SupformData.value.SupplierId != null &&
        ItemData.value.ItemId &&
        (ItemData.value.IsValid
          ? true
          : ItemData.value.FromDate && ItemData.value.ToDate)
      ) {
        console.log(ItemData.value);
        let AddData: any = ref([]);
        let data1 = {};
        const regex = /^\d{2}-\d{2}-\d{4}$/;
        let FromDate = regex.test(ItemData.value.FromDate)
          ? ItemData.value.FromDate
          : moment(ItemData.value.FromDate).format("DD-MM-YYYY");
        let ToDate = regex.test(ItemData.value.ToDate)
          ? ItemData.value.ToDate
          : moment(ItemData.value.ToDate).format("DD-MM-YYYY");

        data1["Itemname1"] = ItemData.value.Itemname1;
        data1["ItemId"] = ItemData.value.ItemId;
        data1["ItemCode"] = ItemData.value.ItemCode;
        data1["FromDate"] = FromDate == "Invalid date" ? "" : FromDate;
        data1["ToDate"] = ToDate == "Invalid date" ? "" : ToDate;
        data1["IsValid"] = ItemData.value.IsValid;

        AddData.value.push(data1);
        console.log(items.value);
        console.log(data1);

        if (dataItems.value["IsEdit"] == 1) {
          Object.values(items.value).forEach((item1: any) => {
            Object.values(AddData.value).forEach((items: any) => {
              if (item1.ItemId == items.ItemId) {
                // item1.FromDate = items.FromDate;
                // item1.ToDate = items.ToDate;
                item1.IsValid = items.IsValid;
                if (item1.IsValid == true) {
                  item1.FromDate = "";
                  item1.ToDate = "";
                } else {
                  item1.FromDate = items.FromDate;
                  item1.ToDate = items.ToDate;
                }
              }
              disabledval.value = false;
            });
          });
        } else {
          if (items.value.length > 0) {
            let MsgValue = 0;
            Object.values(items.value).forEach((item1: any) => {
              Object.values(AddData.value).forEach((items: any) => {
                if (item1.ItemId == items.ItemId) {
                  toast.add({
                    severity: "info",
                    summary: "Item Already Exists",
                    detail: "",
                    life: 3000,
                  });
                  MsgValue = 1;
                  return;
                }
              });
            });
            if (MsgValue == 0) {
              items.value.push(data1);
              disabledval.value = false;
            }
          } else {
            items.value.push(data1);
            disabledval.value = false;
          }
        }

        ItemData.value.Itemname1 = "";
        ItemData.value.ItemId = 0;
        ItemData.value.FromDate = "";
        ItemData.value.ToDate = "";
        dataItems.value["IsEdit"] = 0;
        ItemData.value.IsValid = 0;
        AddBtnName.value = "Add";
      } else {
        if (SupformData.value.SupplierId == null) {
          toast.add({
            severity: "warn",
            summary: "Supplier Required",
            detail: "Please select the supplier before add.",
            life: 3000,
          });
          return;
        } else if (
          ItemData.value.ItemId == 0 ||
          ItemData.value.ItemId == null
        ) {
          toast.add({
            severity: "warn",
            summary: "Item Name Required",
            detail: "Please provide the item name before add.",
            life: 3000,
          });
          return;
        } else if (ItemData.value.FromDate == null) {
          toast.add({
            severity: "warn",
            summary: "From Date Required",
            detail: "Please provide the from date before add.",
            life: 3000,
          });
          return;
        } else if (ItemData.value.ToDate == null) {
          toast.add({
            severity: "warn",
            summary: "To Date Required",
            detail: "Please provide the to date before add.",
            life: 3000,
          });
          return;
        }
      }
    }

    function TableEdit(data) {
      debugger;
      ItemData.value.Itemname1 = data.Itemname1;
      ItemData.value.ItemId = data.ItemId;
      ItemData.value.ItemCode = data.ItemCode;
      ItemData.value.FromDate = data.FromDate;
      ItemData.value.ToDate = data.ToDate;
      ItemData.value.IsValid = data.IsValid;
      disabledval.value = true;
      AddBtnName.value = "Update";
    }

    let ItemsBySupplierId = ref([]);

    function handleItemUpdate(updatedItems) {
      debugger;
      console.log(updatedItems);
    }

    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(routers, 2);
    }
    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (items.value.length > 1) {
        if (
          data["RateContractMappingId"] &&
          data["RateContractMappingId"] != 0
        ) {
          let result = await RateContractService.deleteItems(
            data.RateContractMappingId
          );
          msg = result["ErrorInfo"].ErrorCode;
        }
        if (msg == null) {
          items.value = items.value.filter(
            (item) => item["ItemId"] !== data.ItemId
          );
          toast.add({
            severity: "info",
            summary: "Item Removed",
            detail: "",
            life: 3000,
          });
          return;
        }
      } else {
        toast.add({
          severity: "info",
          summary: "Cannot Delete Last Item",
          detail: "You cannot delete the last remaining item.",
          life: 3000,
        });
        return;
      }
      console.log(items.value);
    }

    let SupformData = ref({
      SupplierId: ref(),
    });

    let showFields = {
      // Category: true,
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      MRP: {
        show: true,
        require: true,
      },
      Discount: {
        show: true,
        require: false,
      },
      FromDate: {
        show: true,
        require: true,
      },
      ToDate: {
        show: true,
        require: true,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
    };

    var arr: any = [];

    const columns = [
      {
        header: t("storetabdetails.RateContractCreationTable.Code"),
        field: "ItemCode",
        class: "smallwidth",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: t("storetabdetails.RateContractCreationTable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      // {
      //   header: "Reorder level",
      //   field: "ReOrderLevel",
      //   editable: false,
      // },
      // {
      //   header: "Quantity requested",
      //   field: "ItemQuantity",
      // },
      {
        header: t("storetabdetails.RateContractCreationTable.FromDate"),
        field: "FromDate",
        editable: false,
        slot: "FromDate",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.RateContractCreationTable.ToDate"),
        field: "ToDate",
        editable: false,
        slot: "ToDate",
        class: "smallwidth",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
      // {
      //     header: 'Quantity value',
      //     field: 'Quantity value'
      // },

      // { field: "action", header: "Action", slot: "action",
      // frozencolumn: true, sortable: false },
    ];

    onMounted(() => {
      // const originalDate = 'Tue May 23 2023 00:00:00 GMT+0530 (India Standard Time)';
      // const dateObj = new Date(originalDate);
      // const convertedDate = dateObj.toISOString();
      // alert(convertedDate)
      debugger;
      let RatecontractId = Number(router.query.Id);
      if (RatecontractId != 0) {
        IsEdit();
      }
    });

    let SupplierDropDownDisable = ref(false);

    async function IsEdit() {
      debugger;
      loading.value = true;
      try {
        let response = await RateContractService.getfindonedata(EditID);
        let responseitem = await RateContractService.getitemsbyrateid(
          EditID,
          HospitalId
        );

        const data1 = response["result"];
        SupformData.value.SupplierId = data1["SupplierId"];
        SupplierDropDownDisable.value = true;
        debugger;
        items.value = responseitem["result"];
        console.log(items.value);
        for (let i = 0; i < items.value.length; i++) {
          const element = items.value[i];
          if (element.IsValid == true) {
            element.FromDate = "";
            element.ToDate = "";
          } else {
            element.FromDate = moment(element.FromDate, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            );
            element.ToDate = moment(element.ToDate, "DD-MM-YYYY").format(
              "DD-MM-YYYY"
            );
          }
        }
        console.log(items.value);
        loading.value = false;
        // Object.keys(SupformData.value).forEach((key) => {
        //   if (data1[key]) SupformData.value[key] = data1[key];
        // });
      } catch (error) {
        //loading.value = false;
        console.log(error);
      }
    }
    const globalFilterFields = ref(columns.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    async function IsSubmit() {
      try {
        debugger;
        if (items.value.length == 0) {
          toast.add({
            severity: "warn",
            summary: "Item Required",
            detail: "Please add an item before proceeding.",
            life: 3000,
          });
          return;
        } else {
          //loading.value = true;
          let RatecontractId = Number(router.query.Id);
          rccreate.value.StoreId = Number(StoreId);
          rccreate.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          rccreate.value.ModifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          rccreate.value.BranchId = BranchId;
          rccreate.value.HospitalId = HospitalId;
          rccreate.value.ModifiedBy = UserId;
          rccreate.value.CreatedBy = UserId;
          rccreate.value.EntityId = 3040;
          rccreate.value.EntityOperationId = 3040001;
          rccreate.value.IsValid = ItemData.value.IsValid;
          let result: any = "";
          let refid;

          if (RatecontractId!) {
            debugger;
            rccreate.value.Id = RatecontractId;
            const form = Object.assign(rccreate.value, SupformData.value);
            result = await RateContractService.updatedata(form);
            refid = RatecontractId;
          } else {
            const form = Object.assign(rccreate.value, SupformData.value);
            result = await RateContractService.createdata(form);
            refid = result["result"];
          }

          let message = result["ErrorInfo"].ErrorCode;

          if (message == null) {
            debugger;

            let LineItems: any = items.value;
            for (let i = 0; i < LineItems.length; i++) {
              let obj = {};

              let RateContractMappingId = 0;
              if (LineItems[i]["RateContractMappingId"] != 0) {
                RateContractMappingId = LineItems[i]["RateContractMappingId"];
              }

              (obj["Id"] = RateContractMappingId),
                (obj["ItemId"] = LineItems[i]["ItemId"]),
                (obj["IsValid"] = LineItems[i]["IsValid"] == 0 ? false : true),
                (obj["RefId"] = refid);
              obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
              obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
              if (obj["IsValid"] == false) {
                obj["FromDate"] = moment(
                  LineItems[i]["FromDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
                obj["ToDate"] = moment(
                  LineItems[i]["ToDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["FromDate"] = "";
                obj["ToDate"] = "";
              }
              (obj["UnitRate"] = LineItems[i]["UnitRate"]
                ? LineItems[i]["UnitRate"]
                : 0.0),
                (arr[i] = obj);
            }

            console.log(arr);
            let result = await RateContractService.ratecontractmapping(arr);
            console.log(result["result"]);

            //loading.value = false;

            let msgMapping = result["ErrorInfo"].ErrorCode;
            if (!RatecontractId) {
              successpop.value = true;
            } else {
              updatepop.value = true;
            }
          }
        }
      } catch (error) {
        // loading.value = false;
      }
    }

    const successpop = ref(false);

    let calcValues = ref({
      grossamount: 0.0,
    });
    function TotalGrossCalc(value1) {
      debugger;
      calcValues.value.grossamount = value1.grossamount;
    }
    let chkDisabled = ref({
      datepicker: false,
    });
    function AlwaysValidChng() {
      chkDisabled.value.datepicker = ItemData.value.IsValid ? true : false;
      if (ItemData.value.IsValid) {
        ItemData.value.FromDate = "";
        ItemData.value.ToDate = "";
      }
    }

    return {
      globalFilterFields,
      filters,
      loading,
      loading1,
      IsItemDelete,
      successpop,
      closetrigger,
      visible,
      updatepop,
      rccreate,
      items,
      TotalGrossCalc,
      commonItemProps,
      // AddItems,
      dataItems,
      IsItemEdit,
      // List,
      IsSubmit,
      SupformData,
      columns,
      showFields,
      itemDatas,

      ItemData,
      LoadItem,
      LoadItemName,
      ItemOnChange,
      IsAddItem,
      ItemsBySupplierId,
      handleItemUpdate,
      disabledval,
      SupplierDropDownDisable,
      SupplierValue,
      AlwaysValidChng,
      chkDisabled,
      TodayDate,
      AddBtnName,
    };
  },
});
</script>
